// export const SERVER_URL = "https://payxtremeapi.secretdemo.com"; // For Client
export const SERVER_URL = "https://devapipayxtreme.secretdemo.com"; // For Sufalam
//  export const SERVER_URL = "https://api.payxtreme.com"; // For AWS
// export const SERVER_URL = "http://localhost:3001";
